import React from "react";
import { useLocation } from "react-router-dom";
import SignIn from "./signin";
import NotFound from "../404";


const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};


const isTimestampValid = (ewdser) => {
  const currentTime = Date.now();
  return (currentTime - ewdser) <= 15000;
};

const SignInWithValidation = () => {
  const query = useQuery();
  const aaddeef = query.get("aaddeef");
  const ewdser = query.get("ewdser");

  if (!aaddeef || !ewdser || !isTimestampValid(Number(ewdser))) {
    return <NotFound />;
  }

  return <SignIn />;
};

export default SignInWithValidation;
